import comp from "./AttachmentList";
export default comp;
